import { useTheme } from '@mui/material/styles';
import { StatusChip } from './StatusChip';


const statusPalette = (theme, status) => {
    let result
    switch (status?.toLowerCase()) {
        case 'awaiting site visit': // Fall through
            result = theme.palette.statusActive
            break;
        case 'new':                     // Fall through
            result = theme.palette.statusPaused
            break
        case 'closed':           // Fall through
        case 'cancelled':
            result = theme.palette.statusComplete
            break
        default:
            result = theme.palette.statusIdle
    }
    return result
}

export default function IcpInspectionStatusChip({status, icpStatusReason, ...props}) {
    const theme = useTheme();
    const chipPalette = statusPalette(theme, status)
    return (
        <StatusChip
            status={status}
            statusReason={icpStatusReason}
            chipPalette={chipPalette}
            {...props} />
 
    )
}

